import React from "react";
import { Box, Typography, Tooltip } from "@mui/material";
import TableCell from "@mui/material/TableCell";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";

// Columna "Estado": badge con el estado de la solicitud. Si está
// RECHAZADO/NO APLICA y el usuario tiene permiso, al pasar el mouse aparece un
// overlay para pre-aprobar. El resto de los estados usan colores fijos según
// `data.estado`.
export default function CeldaEstado({
  data,
  permisoAprobarEstado,
  setCurrentAction,
  setCurrentData,
  setOpenDialog2,
  handlePopoverOpen,
}) {
  return (
    <TableCell align="center">
      {(data.estado === "RECHAZADO" || data.estado === "NO APLICA" || data.estado === "RE-PROCESO") ? (
        <Box
          sx={{
            position: "relative",
            display: "inline-block",
            ...(permisoAprobarEstado(data)
              ? {}
              : {
                "&:hover .approveOverlay": {
                  transform: "translateY(0)",
                  opacity: 1,
                },
              }),
          }}
        >
          <Box
            component="span"
            sx={{
              display: "inline-flex",
              px: 1.5,
              py: 0.5,
              fontSize: "0.75rem",
              fontWeight: 600,
              borderRadius: "9999px",
              textTransform: "uppercase",
              letterSpacing: "0.05em",
              backgroundColor: data.estado === "RE-PROCESO" ? "#ffedd5" : "#fee2e2",
              color: data.estado === "RE-PROCESO" ? "#c2410c" : "#b91c1c",
              transition: "all 0.3s ease",
            }}
          >
            {data.estado}
          </Box>
          {!permisoAprobarEstado(data) && (
            <Box
              className="approveOverlay"
              onClick={() => {
                setCurrentAction("estado");
                setCurrentData(data); // Guarda la fila actual
                setOpenDialog2(true); // Abrir el diálogo para confirmar
              }}
              sx={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                bgcolor: "#dbeafe",
                borderRadius: "9999px",
                cursor: "pointer",
                transform: "translateY(100%)",
                opacity: 0,
                transition:
                  "transform 0.3s ease, opacity 0.3s ease",
              }}
            >
              <Typography
                sx={{
                  color: "#1e40af",
                  fontSize: "0.75rem",
                  fontWeight: 600,
                  display: "flex",
                  alignItems: "center",
                  gap: 0.5,
                }}
              >
                <CheckCircleIcon fontSize="small" />
                PRE-APROBAR?
              </Typography>
            </Box>
          )}
        </Box>
      ) : (
        <Box
          component="span"
          sx={{
            display: "inline-flex",
            px: 1.5,
            py: 0.5,
            fontSize: "0.75rem",
            fontWeight: 600,
            borderRadius: "9999px",
            textTransform: "uppercase",
            letterSpacing: "0.05em",
            backgroundColor: (() => {
              switch (data.estado) {
                case "APROBADO":
                  return "#dcfce7"; // verde claro
                case "PRE-APROBADO":
                  return "#dbeafe"; // azul claro
                case "ANULADO":
                  return "#f3f4f6"; // gris claro
                case "FACTURADO":
                  return "#d1fae5"; // emerald-100 (antes verde sólido #166534 con texto blanco)
                case "RECHAZADO":
                  return "#fee2e2"; // rojo claro
                case "CORRECCIÓN":
                  return "#fef9c3"; // amarillo claro
                case "PENDIENTE":
                  return "#fef9c3";
                case "DATOS CLIENTE":
                  return "#e0f2fe"; // azul muy claro
                case "NOTA DE CRÉDITO":
                  return "#ffedd5"; // orange-100 (antes sólido #e76843 con texto blanco)
                case "NOTA DE CRÉDITO AUTOMÁTICA":
                  return "#fed7aa"; // orange-200 (antes sólido #FF8C00 con texto blanco)
                case "RE-PROCESO":
                  return "#ffedd5"; // naranja claro
                default:
                  return "#f3f4f6"; // gris por defecto
              }
            })(),
            color: (() => {
              switch (data.estado) {
                case "APROBADO":
                  return "#166534"; // verde fuerte
                case "PRE-APROBADO":
                  return "#1e40af"; // azul fuerte
                case "ANULADO":
                  return "#374151"; // gris oscuro
                case "FACTURADO":
                  return "#065f46"; // emerald-800
                case "RECHAZADO":
                  return "#b91c1c"; // rojo fuerte
                case "CORRECCIÓN":
                  return "#854d0e"; // marrón oscuro
                case "PENDIENTE":
                  return "#854d0e";
                case "DATOS CLIENTE":


                  return "#1e3a8a"; // azul medio
                case "NOTA DE CRÉDITO":
                  return "#9a3412"; // orange-800
                case "NOTA DE CRÉDITO AUTOMÁTICA":
                  return "#7c2d12"; // orange-900
                case "RE-PROCESO":
                  return "#c2410c"; // naranja fuerte
                default:
                  return "#4b5563"; // gris medio
              }
            })(),
          }}
        >
          {data.estado}
        </Box>

      )}

      <div style={{ height: 12 }} />

      <span
        className="flex justify-end items-center "
      >
        {(data.CuotasGratis == 1 || data.CuotasGratis === true) && (
          <Tooltip title="cuota gratis">
            <CardGiftcardIcon 
              style={{ color: "#d97706", marginRight: "8px" }} 
              fontSize="small" 
            />
          </Tooltip>
        )}
        <MoreVertIcon
          onClick={(event) =>
            handlePopoverOpen(event, 6, data)
          }
          style={{ cursor: "pointer" }}
          className="ml-2 text-slate-400 hover:text-slate-600 transition-colors duration-200"
        />
      </span>

    </TableCell>
  );
}
